import { useEffect, useState } from "react";
import apiCall from "../../helpers/apifactory";

import * as Yup from "yup";
import { useFormik } from "formik";
import ErrorText from "./ErrorText";

import Select from "react-select";
import Rates from "../Pages/Rates";

const RateTariff = () => {
  const [showRates, setShowRates] = useState(false);
  const [shipmentType, setShipmentType] = useState("domestic");

  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);

    setTimeout(() => {
      const element = document.getElementById(current_page);

      if (element) {
        element.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    }, 100);

    const handleScroll = () => {
      let top = window.scrollY;

      let window_width = window.innerWidth;

      let header = document.querySelector("header");

      let header_height = header ? header.offsetHeight + 100 : 100;

      const nav = document.querySelector("nav");

      if (nav) {
        if (top > header_height && window_width > 1024) {
          nav.classList.add("fixed-header-desktop");
        } else {
          nav.classList.remove("fixed-header-desktop");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [city, setCities] = useState([]);
  const [rateData, setRateData] = useState(null);
  const [setDestState] = useState("");
  const [originState, setOriginState] = useState("");
  const [newcities, setNewCities] = useState([]);
  const [countries, setCountries] = useState([]);

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(originState ? true : false);
  }, [originState]);

  useEffect(() => {
    apiCall
      .getCity()
      .then((res) => {
        var cityarr = res?.data?.responseData?.cities?.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setCities(res?.data?.responseData?.cities);
        setNewCities(cityarr);
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);

  useEffect(() => {
    apiCall
      .getIntCountries()
      .then((res) => {
        const countriesArr = res?.data?.responseData?.cities?.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setCountries(countriesArr || []);
      })
      .catch((error) => {
        console.log("getIntCountries error", error);
      });
  }, []);

  useEffect(() => {
    formik?.setFieldValue("destination", undefined);
  }, [shipmentType]);

  const formik = useFormik({
    initialValues: {
      originState: undefined,
      destination: undefined,
      weight: "",
      zipcode: "",
    },
    validationSchema: Yup.object({
      originState: Yup.object().required("This is Required"),
      destination: Yup.object().required("This is Required"),
      weight: Yup.string().required("This is Required"),
      zipcode: Yup.string().matches(
        /^[A-Za-z0-9\s-]{3,10}$/,
        "Invalid Zip Code format"
      ),
    }),

    onSubmit: (values) => {
      const data = {
        weight: values?.weight,
        origin: values?.originState?.value,
        originLabel: values?.originState?.label,
        dstn: values?.destination?.value?.split("-")[0],
        dstnLabel: values?.destination?.label,
        ...(shipmentType === "international" && { intl: "1" }),
        ...(shipmentType === "international" && {
          zipcode: String(values?.zipcode || ""),
        }),
      };

      setRateData(data);
      setShowRates(true);
    },
  });

  useEffect(() => {
    formik.setFieldValue("originState", "");
    formik.setFieldValue("destination", "");
    formik.setFieldValue("zipcode", "");
    formik.setFieldValue("weight", "");
    setShowRates(false);
  }, [shipmentType]);

  return (
    <div>
      <div className="flex flex-col sm:mx-[4rem] mx-2 mt-[.5rem] flex-wrap mb-[.5rem]">
        <div className="flex flex-col gap-1 px-4 py-1 shadow-my-lg text-sm md:w-[45rem] sm:w-[40rem] sm:mx-[auto] rounded-md transition-all duration-500">
          <h2 className="font-bold text-[1.1rem]">Get a quote form</h2>

          {/* Shipment Type Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mt-3 mb-4">
            <button
              type="button"
              onClick={() => setShipmentType("domestic")}
              className={`flex-1 py-2.5 sm:py-3 px-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] ${
                shipmentType === "domestic"
                  ? "bg-gradient-to-r from-[#D40511] to-[#F21E26] text-white shadow-lg shadow-red-500/25 border-2 border-transparent"
                  : "bg-white text-gray-600 border-2 border-gray-200 hover:border-[#D40511] hover:text-[#D40511] hover:shadow-md"
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-truck-icon lucide-truck"
                >
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                  <path d="M15 18H9" />
                  <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                  <circle cx="17" cy="18" r="2" />
                  <circle cx="7" cy="18" r="2" />
                </svg>
                Domestic
              </span>
            </button>
            <button
              type="button"
              onClick={() => setShipmentType("international")}
              className={`flex-1 py-2.5 sm:py-3 px-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] ${
                shipmentType === "international"
                  ? "bg-gradient-to-r from-[#D40511] to-[#F21E26] text-white shadow-lg shadow-red-500/25 border-2 border-transparent"
                  : "bg-white text-gray-600 border-2 border-gray-200 hover:border-[#D40511] hover:text-[#D40511] hover:shadow-md"
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-plane-icon lucide-plane"
                >
                  <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                </svg>
                International
              </span>
            </button>
          </div>

          {/* Form Fields - Responsive Grid */}
          <div
            className={`grid grid-cols-1 md:grid-cols-2 gap-2 mt-2 ${
              shipmentType === "international"
                ? "lg:grid-cols-4"
                : "lg:grid-cols-3"
            }`}
          >
            {/* Origin Field */}
            <div className="relative">
              <Select
                className="select1"
                placeholder="Origin (city)"
                name="originState"
                id="originState"
                value={formik?.values?.originState}
                options={newcities}
                onChange={(e) => {
                  formik?.setFieldValue("originState", e);
                }}
                onBlur={(e) => {
                  formik?.setFieldTouched("originState", true);
                }}
              />
              <ErrorText
                text={
                  formik?.touched?.originState && formik?.errors?.originState
                }
              />
            </div>

            {/* Destination Field */}
            <div className="relative">
              <Select
                className="select1 "
                placeholder={
                  shipmentType === "international"
                    ? "Destination(Country)"
                    : "Destination(City)"
                }
                name="destination"
                id="destination"
                value={formik?.values?.destination}
                options={
                  shipmentType === "international" ? countries : newcities
                }
                onChange={(e) => {
                  formik?.setFieldValue("destination", e);
                }}
                onBlur={(e) => {
                  formik?.setFieldTouched("destination", true);
                }}
              />
              <ErrorText
                text={
                  formik?.touched?.destination && formik?.errors?.destination
                }
              />
            </div>

            {/* Weight Field */}
            <div className="MuiFormControl-root MuiTextField-root">
              <div className="relative">
                {/* <input
                  required
                  type="number"
                  value={formik?.values?.weight}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (value &&
                        parseFloat(value) <= 99999 &&
                        parseFloat(value) >= 1)
                    ) {
                      formik.setFieldValue("weight", value);
                    }
                  }}
                  name="weight"
                  min={1}
                  max={9999}
                  onBlur={formik?.handleBlur}
                  onWheel={(e) => e.target.blur()}
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                  maxLength={4}
                /> */}
                {/* <label
                  htmlFor="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/3 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Weight (kg)*
                </label>

                <ErrorText
                  text={formik?.touched?.weight && formik?.errors?.weight}
                /> */}
                {/* <input
                  id="weight"
                  type="text"
                  placeholder=""
                  value={formik?.values?.weight}
                  onBlur={formik?.handleBlur}
                  className="block px-2.5 pb-2 pt-2 w-full text-sm bg-transparent rounded border border-gray peer"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "") {
                      formik.setFieldValue("weight", value);
                      return;
                    }

                    if (!/^\d*\.?\d*$/.test(value)) return;

                    const [intPart, decPart] = value.split(".");

                    if (intPart.length > 5) return;

                    if (intPart.length === 5 && value.includes(".")) return;

                    if (decPart) {
                      if (intPart.length === 4 && decPart.length > 1) return;

                      if (intPart.length < 4 && decPart.length > 2) return;
                    }

                    formik.setFieldValue("weight", value);
                  }}
                /> */}
                <input
                  id="weight"
                  type="text"
                  inputMode="decimal"
                  value={formik.values.weight}
                  name="weight"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "") {
                      formik.setFieldValue("weight", "");
                      return;
                    }

                    if (!/^\d*\.?\d*$/.test(value)) return;

                    const digitCount = value.replace(".", "").length;
                    if (digitCount > 5) return;

                    if (value.startsWith("99999") && value.includes("."))
                      return;

                    const num = Number(value);
                    if (!isNaN(num) && num <= 99999) {
                      formik.setFieldValue("weight", value);
                    }
                  }}
                  onPaste={(e) => {
                    const pasted = e.clipboardData.getData("text");

                    if (
                      !/^\d*\.?\d*$/.test(pasted) ||
                      pasted.replace(".", "").length > 5 ||
                      (pasted.startsWith("99999") && pasted.includes(".")) ||
                      Number(pasted) > 99999
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  onBlur={formik.handleBlur}
                  className="block px-2.5 pb-2 pt-2 w-full text-sm bg-transparent rounded border border-gray peer"
                />
                <label
                  htmlFor="weight"
                  className={`absolute left-1 bg-white px-1 text-xs transition-all duration-200 ${
                    formik.values.weight
                      ? "top-2 -translate-y-4 scale-75 text-red-600"
                      : "top-[35%] -translate-y-1/2 scale-100 text-gray-500"
                  } peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:text-red-600
    `}
                >
                  Weight (kg)*
                </label>
                <ErrorText
                  text={formik?.touched?.weight && formik?.errors?.weight}
                />
              </div>
            </div>

            {/* Postal Code Field */}
            {shipmentType === "international" && (
              <div className="MuiFormControl-root MuiTextField-root">
                <div className="relative">
                  <div className="relative">
                    <input
                      id="zipcode"
                      required
                      type="text"
                      value={formik?.values?.zipcode}
                      onChange={formik?.handleChange}
                      name="zipcode"
                      maxLength={20}
                      onBlur={formik?.handleBlur}
                      placeholder=" "
                      className="
      peer
      block
      w-full
      
      px-3
      text-sm
      bg-transparent
      border
      border-gray
      rounded
      focus:outline-none
      focus:ring-0
      focus:border-red-600
    "
                    />

                    <label
                      htmlFor="zipcode"
                      className="
      absolute
      left-1
      top-1/2
      -translate-y-1/2
      text-xs
      text-gray-500
      bg-white
      px-2
      transition-all
      duration-300

      peer-focus:top-1.5
      peer-focus:text-red-600
      peer-focus:scale-75
      peer-focus:-translate-y-4

      peer-placeholder-shown:top-1/2
      peer-placeholder-shown:scale-100
      peer-placeholder-shown:-translate-y-1/2
    "
                    >
                      Postal Code
                    </label>
                  </div>

                  <ErrorText
                    text={formik?.touched?.zipcode && formik?.errors?.zipcode}
                  />
                </div>
              </div>
            )}
          </div>

          <button
            type="submit"
            onClick={() => {
              formik?.handleSubmit();
            }}
            className="text-white bg-[#D40511] border border-[#F21E26] w-full mt-[.5rem] rounded-md mb-2 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Submit
          </button>
        </div>

        {showRates && rateData && (
          <Rates
            weight={rateData.weight}
            origin={rateData.origin}
            dstn={rateData.dstn}
            intl={rateData.intl}
            zipcode={rateData.zipcode}
            originLabel={rateData.originLabel}
            dstnLabel={rateData.dstnLabel}
          />
        )}
      </div>
    </div>
  );
};

export default RateTariff;
